import { companyPartialUpdaterBuilder } from "../companyPartialUpdaterBuilder";
import {
  CompanyLocationFormik,
  COMPANY_LOCATION_MESSENGER_CONTEXT,
  validationCompanyLocationSectionSchema,
} from "./CompanyLocationForm";

export const CompanyLocationEdit = companyPartialUpdaterBuilder(CompanyLocationFormik, {
  validationSchema: validationCompanyLocationSectionSchema,
  messengerContext: COMPANY_LOCATION_MESSENGER_CONTEXT,
});
